import vbDenChoXuLyIndex from "../views/doc-in/vbDenChoXuLyIndex.vue";
import vbDenToTrinhQuaHanIndex from "../views/doc-in/to-trinh-qua-han/vb-den-to-trinh-qua-han-index.vue";
import vbDenDaXuLyIndex from "../views/doc-in/vbDenDaXuLyIndex.vue";
import vbDenThuHoiIndex from "../views/doc-in/vbDenThuHoiIndex.vue";
import vbDenDaXuLyVTIndex from "../views/doc-in/vbDenDaXuLyVTIndex.vue";
import vbDenDaTiepNhanIndex from "../views/doc-in/vbDenDaTiepNhanIndex.vue";
import Index from "../views/doc-in/Index.vue";
import VbDaVaoSoIndex from "../views/doc-in/vbDaVaoSoIndex.vue";
import Detail from "../views/doc-in/detail-v2.vue";
import Create from "../views/doc-in/Create.vue";
import vbDenUyQuyenIndex from "../views/doc-in/vbDenUyQuyenIndex";

export default [
  {
    path: "/app/:userDeptRoleId/vbDaVaoSo",
    name: "vbDaVaoSo",
    component: VbDaVaoSoIndex
  },
  {
    path: "/app/:userDeptRoleId/vbDaVaoSo/detail/:id",
    name: "vbDaVaoSoDetail",
    components: {
      default: VbDaVaoSoIndex,
      detail: Detail
    }
  },
  {
    path: "/app/:userDeptRoleId/vbChoTiepNhan",
    name: "vbChoTiepNhan",
    component: Index
  },

  {
    path: "/app/:userDeptRoleId/vbChoTiepNhan/edit/:id",
    name: "vbChoTiepNhanEdit",
    components: {
      default: Index,
      detail: Create
    }
  },
  {
    path: "/app/:userDeptRoleId/vbChoTiepNhan/create",
    name: "vbChoTiepNhanCreate",
    components: {
      default: Index,
      detail: Create
    }
  },
  {
    path: "/app/:userDeptRoleId/vbChoTiepNhan/detail/:id",
    name: "vbChoTiepNhanDetailEditable",
    components: {
      default: Index,
      detail: () => import("../views/doc-in/detailEditable")
    }
  },
  {
    path: "/app/:userDeptRoleId/vbDenChoXuLy",
    name: "vbDenChoXuLy",
    component: vbDenChoXuLyIndex
  },
  {
    path: "/app/:userDeptRoleId/vbDenChoXuLy/detail/:id",
    name: "vbDenChoXuLyDetail",
    components: {
      default: vbDenChoXuLyIndex,
      detail: Detail
    }
  },
  {
    path: "/app/:userDeptRoleId/vbDenUyQuyen",
    name: "vbDenUyQuyen",
    component: vbDenUyQuyenIndex
  },
  {
    path: "/app/:userDeptRoleId/vbDenUyQuyen/detail/:id",
    name: "vbDenUyQuyenDetail",
    components: {
      default: vbDenUyQuyenIndex,
      detail: Detail
    }
  },
  {
    path: "/app/:userDeptRoleId/vbDenDaXuLy",
    name: "vbDenDaXuLy",
    component: vbDenDaXuLyIndex
  },
  {
    path: "/app/:userDeptRoleId/vbDenDaXuLy/detail/:id",
    name: "vbDenDaXuLyDetail",
    components: {
      default: vbDenDaXuLyIndex,
      detail: Detail
    }
  },
  {
    path: "/app/:userDeptRoleId/vbDenDaTiepNhan",
    name: "vbDenDaTiepNhan",
    component: vbDenDaTiepNhanIndex
  },
  {
    path: "/app/:userDeptRoleId/vbDenDaTiepNhan/detail/:id",
    name: "vbDenDaTiepNhanDetail",
    components: {
      default: vbDenDaTiepNhanIndex,
      detail: Detail
    }
  },

  {
    path: "/app/:userDeptRoleId/vbDenDaXuLyVT",
    name: "vbDenDaXuLyVT",
    component: vbDenDaXuLyVTIndex
  },
  {
    path: "/app/:userDeptRoleId/vbDenDaXuLyVT/detail/:id",
    name: "vbDenDaXuLyVTDetail",
    components: {
      default: vbDenDaXuLyVTIndex,
      detail: Detail
    }
  },

  {
    path: "/app/:userDeptRoleId/vbDenThuHoi",
    name: "vbDenThuHoi",
    component: vbDenThuHoiIndex
  },
  {
    path: "/app/:userDeptRoleId/vbDenThuHoi/detail/:id",
    name: "vbDenThuHoiDetail",
    components: {
      default: vbDenThuHoiIndex,
      detail: Detail
    }
  },
  {
    path: "/app/:userDeptRoleId/toTrinhQuaHan",
    name: "toTrinhQuaHan",
    component: vbDenToTrinhQuaHanIndex
  },
  {
    path: "/app/:userDeptRoleId/toTrinhQuaHan/detail/:id",
    name: "toTrinhQuaHanDetail",
    components: {
      default: vbDenToTrinhQuaHanIndex,
      detail: Detail
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/document-in.js